// Formatage des montants et dates de l'abonnement (VIG-450), comme dans les maquettes :
// « 672 € », « 6 720 € », « 1er septembre 2026 ».

// Séparateur des milliers : espace insécable normale (U+00A0), comme FrenchFormat::euros()
// côté serveur. fr-FR produit une espace fine insécable (U+202F) selon les navigateurs.
export function euros(value) {
    return Number(value)
        .toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})
        .replace(/,00$/, '')
        .replace(/[  ]/g, ' ');
}

export function longDate(value, {withYear = true} = {}) {
    if (!value) {
        return '';
    }
    const date = toDate(value);
    const day = date.getDate() === 1 ? '1er' : String(date.getDate());
    const month = date.toLocaleDateString('fr-FR', {month: 'long'});

    return withYear ? `${day} ${month} ${date.getFullYear()}` : `${day} ${month}`;
}

// « octobre 2026 ».
export function monthName(value) {
    return toDate(value).toLocaleDateString('fr-FR', {month: 'long', year: 'numeric'});
}

// « octobre », sans l'année.
export function monthOnly(value) {
    return toDate(value).toLocaleDateString('fr-FR', {month: 'long'});
}

// Mois précédé de « de », élidé devant une voyelle, comme FrenchFormat::ofMonth() côté
// serveur : « de septembre 2026 », « d'octobre 2026 », « d'août » (sans l'année).
export function deMonth(value, {withYear = true} = {}) {
    const month = withYear ? monthName(value) : monthOnly(value);

    return (/^[aeiouyàâéèêîôû]/i.test(month) ? "d'" : 'de ') + month;
}

export function notairesLabel(n) {
    return `${n} ${n > 1 ? 'notaires' : 'notaire'}`;
}

// Montant d'une période d'abonnement pour n notaires déclarés, à partir des prix de la
// formule envoyés par le serveur (TeamSubscriptionPricingService) : 1er notaire + notaires
// supplémentaires. Mensuel : 240 + 216 × (n − 1) ; Annuel : 2 400 + 2 160 × (n − 1).
export function planTotal(plan, n) {
    return plan.firstNotairePrice + plan.additionalNotairePrice * (Math.max(1, n) - 1);
}

// Équivalent mensuel d'un montant annuel, arrondi au centime : 6 720 → 560.
export function perMonth(annualAmount) {
    return Math.round(annualAmount / 12 * 100) / 100;
}

// Offre spécifique de l'office (`subscription.offer`, VIG-450 R20 à R23) : s'applique-t-elle
// à l'abonnement ('abonnement') ou aux dossiers à l'usage ('usage') ? Jamais avant son mois
// de début (D6) ni après sa fin (D8) : l'offre reste affichée, sans remise.
export function offerApplies(offer, scope) {
    if (!offer || offer.inEffect === false) {
        return false;
    }
    return scope === 'usage' ? offer.appliesToUsage : offer.appliesToSubscription;
}

// Montant après la remise de l'offre, arrondi au centime, comme
// SpecificOfferService::discount() côté serveur : 672 à −10 % = 604,80. Sert aux montants
// calculés à l'écran (simulateur, récapitulatif) ; les montants fixes viennent du serveur.
export function withOffer(amount, offer, scope = 'abonnement') {
    if (!offerApplies(offer, scope)) {
        return amount;
    }
    return Math.round(amount * (100 - Math.min(offer.discountPercent, 100))) / 100;
}

// Les dates AAAA-MM-JJ sont lues en heure locale, pas en UTC.
function toDate(value) {
    return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
        ? new Date(`${value}T00:00:00`)
        : new Date(value);
}
